// import external dependencies
//import 'jquery';

// Import everything from autoload
import './autoload/_autocomplete.js'; import './autoload/_bootstrap.js';//ToDo: Try to find a way how to remove this

// import local dependencies
import Router from './util/Router';
import common from './v2/common';
import home from './v2/home';
import categories from './v2/categories';
import commonV2 from './v2/commonV2';
import vendorReviews from './v2/vendor-reviews';
import vendorList from './v2/vendor-list';
import compare from './v2/compare';
import oneVsOne from './v2/oneVsOne';
import pageMav from './v2/mav';

/** Populate Router instance with DOM routes */
const routes = new Router({
  common,//All pages common, V1&V2
  commonV2,//All pages for V2
  home,
  categories,
  vendorReviews,
  vendorList,
  compare,
  oneVsOne,
  pageMav,
});

// Load Events
jQuery(document).ready(() => {
  routes.fire('commonV2');
  routes.loadEvents();
});
